export default {
  name: "Trending",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m30.1 10.09-.7 7.17a1 1 0 1 1-1.99-.19l.55-5.61-9.26 9.26a1 1 0 0 1-1.41 0l-4.79-4.79-8.79 8.79a1 1 0 1 1-1.41-1.41l9.5-9.5a1 1 0 0 1 1.41 0L18 18.59l8.54-8.54-5.59.54a.99.99 0 0 1-1.09-.9 1 1 0 0 1 .9-1.09l7.17-.7a1.98 1.98 0 0 1 2.17 2.19z",
  },
}
